import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

export default function Logout() {
  const out = async () => {
    await signOut(auth);
    window.location.href = '/login';
  };
  return <button className="btn btn-logout" onClick={out}>Logout</button>;
}
